export const REQUEST_SNIPLETS = 'sniplets/REQUEST_SNIPLETS';
export const RECEIVE_SNIPLETS = 'sniplets/RECEIVE_SNIPLETS';
export const UPDATE_SNIPLET = 'sniplets/UPDATE_SNIPLET';
